import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const InsightsPanel = ({ insights }) => {
  const [expandedInsight, setExpandedInsight] = useState(null);

  const toggleInsight = (insightId) => {
    setExpandedInsight(expandedInsight === insightId ? null : insightId);
  };

  const getInsightIcon = (type) => {
    switch (type) {
      case 'compatibility':
        return 'TrendingUp';
      case 'suggestion':
        return 'Lightbulb';
      case 'achievement':
        return 'Award';
      default:
        return 'Info';
    }
  };

  const getInsightColor = (type) => {
    switch (type) {
      case 'compatibility':
        return 'success';
      case 'suggestion':
        return 'primary';
      case 'achievement':
        return 'warning';
      default:
        return 'muted';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6 lg:p-8 shadow-therapeutic">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground">
          AI Insights
        </h3>
        <div className="flex items-center gap-2 text-muted-foreground">
          <Icon name="Sparkles" size={20} color="currentColor" />
          <span className="text-xs md:text-sm font-caption">Powered by AI</span>
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        {insights?.map((insight) => (
          <div
            key={insight?.id}
            className="bg-muted/30 rounded-lg border border-border overflow-hidden transition-therapeutic"
          >
            <button
              onClick={() => toggleInsight(insight?.id)}
              className="w-full flex items-start gap-3 md:gap-4 p-3 md:p-4 text-left hover:bg-muted/50 transition-therapeutic"
            >
              <div className={`flex-shrink-0 flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-${getInsightColor(insight?.type)}/10 rounded-md`}>
                <Icon 
                  name={getInsightIcon(insight?.type)} 
                  size={20} 
                  color={`var(--color-${getInsightColor(insight?.type)})`} 
                />
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-2 mb-1">
                  <h4 className="text-sm md:text-base lg:text-lg font-heading font-medium text-foreground">
                    {insight?.title}
                  </h4>
                  <Icon 
                    name={expandedInsight === insight?.id ? 'ChevronUp' : 'ChevronDown'} 
                    size={20} 
                    color="var(--color-muted-foreground)" 
                    className="flex-shrink-0"
                  />
                </div>
                
                <p className="text-xs md:text-sm text-muted-foreground font-caption line-clamp-2">
                  {insight?.summary}
                </p>

                <div className="flex items-center gap-2 mt-2">
                  <span className="text-xs text-muted-foreground/80">
                    {insight?.timestamp}
                  </span>
                  {insight?.isNew && (
                    <span className="px-2 py-0.5 bg-accent text-accent-foreground rounded text-xs font-medium">
                      New
                    </span>
                  )}
                </div>
              </div>
            </button>

            {expandedInsight === insight?.id && (
              <div className="px-3 md:px-4 pb-3 md:pb-4 pt-0">
                <div className="pl-12 md:pl-16">
                  <p className="text-sm md:text-base text-foreground mb-3 md:mb-4">
                    {insight?.details}
                  </p>

                  {insight?.recommendations && insight?.recommendations?.length > 0 && (
                    <div className="space-y-2">
                      <p className="text-xs md:text-sm font-medium text-muted-foreground">
                        Recommendations:
                      </p>
                      <ul className="space-y-1.5">
                        {insight?.recommendations?.map((rec, index) => (
                          <li key={index} className="flex items-start gap-2 text-xs md:text-sm text-foreground">
                            <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
                            <span>{rec}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InsightsPanel;